/** @internal */
export const isAssignableFromSymbol: unique symbol = Symbol.for("Serenity.isAssignableFrom");
/** @internal */
export const isInstanceOfTypeSymbol: unique symbol = Symbol.for("Serenity.isInstanceOfType");
/** @internal */
export const implementedInterfacesSymbol: unique symbol = Symbol.for("Serenity.implementedInterfaces");
/** @internal */
export const localTextTableSymbol: unique symbol = Symbol.for("Serenity.localTextTable");
/** @internal */
export const scriptDataHashSymbol: unique symbol = Symbol.for("Serenity.scriptDataHash");
/** @internal */
export const scriptDataSymbol: unique symbol = Symbol.for("Serenity.scriptData");
/** @internal */
export const isInterfaceTypeSymbol: unique symbol = Symbol.for("Serenity.isInterfaceType"); // true: interface, false: class, null: enum
/** @internal */
export const typeRegistrySymbol: unique symbol = Symbol.for("Serenity.typeRegistry");

